import { ThemeUICSSObject } from '@apia/theme';

export const aiMessage: ThemeUICSSObject = {
  position: 'relative',

  '.closeButton': {
    borderRadius: '5px',
    right: '0px',
    top: '-2px',
    zIndex: '15',
    position: 'absolute',
    variant: 'buttons.icon-outline-danger',
  },
  '.descriptionButton': {
    borderRadius: '5px',
    right: '28px',
    top: '-2px',
    zIndex: '15',
    position: 'absolute',
    variant: 'buttons.icon-outline',
  },

  genericBox: {
    margin: '10px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px',
  },

  fileBox: {
    variant: 'layout.common.components.aiMessage.genericBox',
    width: '130px',
    height: '120px',
    backgroundColor: '#f0f0f0',
    border: '1px solid #ccc',
    borderRadius: '4px',
    position: 'relative',
    display: 'flex',
    img: {
      objectFit: 'contain',
      width: '110px',
      height: '69px',
    },
  },

  fileName: {
    bottom: '4px',
    right: '4px',
    fontSize: '12px',
    color: '#333',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    width: 'inherit',
    textAlign: 'center',
    px: '5px',
  },

  textBox: {
    variant: 'layout.common.components.aiMessage.genericBox',
    width: '50px',
    padding: '10px',
    backgroundColor: '#fff',
    border: '1px solid #ddd',
    borderRadius: '4px',
    position: 'relative',
  },

  textSnippet: {
    bottom: '4px',
    right: '4px',
    fontSize: '12px',
    color: '#555',
  },
};
